import React, { useState, useRef, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { GlobalContext } from '../../../utils/globalState'
import styles from './styles.module.css'
import Alert from '../../common/Alert'

// component function
export default function NewAnalysis(props) {

	const { tourRef } = props
	const [globalState, setGlobalState] = useContext(GlobalContext)	// eslint-disable-line no-unused-vars
	const history = useHistory()
	const [highlight, setHighlight] = useState()
	const [error, setError] = useState()
	const [alertTask, setAlertTask] = useState()
	const alertObjectRef = useRef(null)
	const fileInputRef = useRef()
	const analysesExtra = globalState.userData?.organization?.freeAnalyses ? globalState.userData.organization.freeAnalyses : 0
	const maxMb = globalState.userData?.organization?.subscriptionPlan?.config?.Max_Mb_per_film ? globalState.userData.organization.subscriptionPlan.config.Max_Mb_per_film : 1000
	const isTouchDevice = ('ontouchstart' in window) || ( navigator.maxTouchPoints > 0 ) || ( navigator.msMaxTouchPoints > 0 )

	// alert setup
	const alert = alertObjectRef.current !== null && alertTask !== undefined && <Alert type={alertObjectRef.current.type} title={alertObjectRef.current.title} message={alertObjectRef.current.message} cancelLabel={alertObjectRef.current.cancelLabel} actionLabel={alertObjectRef.current.actionLabel} action={alertTask} />

	// open file select dialogue
	function openFileDialog() {
		if (globalState.userData?.organization?.subscriptionPlan?.id === 9 && analysesExtra <= 0) { // no analyses on Basic
			showTrialAlert()
		} else {
			fileInputRef.current.click()
		}
	}

	// validate file when added
	function onFileAdded(e) {
		validateFile(e.target.files[0])
	}

	// handle dropped file
	function onDrop(e) {
		e.preventDefault()
		setHighlight(false)
		validateFile(e.dataTransfer.files[0])
	}

	// handle drag enter
	function onDragOver(e) {
		e.preventDefault()
		setHighlight(true)
	}

	// handle drag leave
	function onDragLeave() {
		setHighlight(false)
	}

	// validate file
	function validateFile(file) {
		if (!file) return
		if (globalState.userData?.organization?.subscriptionPlan?.id === 9 && analysesExtra <= 0) { // no analyses on Basic
			showTrialAlert()
		} else {
			let err = null
			err = file.size > maxMb * 1000 * 1000 ? 'Sorry, the video size exceeds the allowed ' + maxMb + ' MB per video' : err
			err = (file.type !== 'video/mp4' && file.type !== 'video/quicktime' && file.type.indexOf('image/') !== 0) ? 'Sorry, flowsam only likes .mp4 or .mov video or image files' : err
			err ? setError(err) : history.push({pathname: '/new-analysis', state: file})
		}
	}

	// show analyses spent alert
	function showTrialAlert() {
		alertObjectRef.current = { title:'Sorry, you don’t have any analyses on your account', message:'Please buy an Ad hoc analysis or upgrade to a Flowsam Unlimited subscription', cancelLabel:'Cancel', actionLabel:'Buy/upgrade', type:'confirm'}
		setAlertTask(()=>(action)=>{ // execute alert
			if (action) { // upgrade
				window.location.href='https://flowsam.ai/pricing-v2/'
			}
			setAlertTask() // remove confirm dialogue
		})
	}

	const dropZoneClass = highlight ? styles.dropZone + ' ' + styles.dropZoneHighlight : styles.dropZone
	const ctaText = isTouchDevice ? 'Tap to select video or image' : 'Drop video or image here\nor click to select'
	const statusText = highlight ? <h4 className={styles.dropZoneHighlight}>Drop it right here</h4> : error ? <h4 className={styles.dropZoneError}>{error}</h4> : (
		<>
			<div className={styles.icons} />
			<h4>New analysis</h4>
			<p>{ctaText}</p>
		</>
	)

	return (
		<>
			<div
				ref={tourRef}
				className={dropZoneClass}
				onDragOver={onDragOver}
				onDragLeave={onDragLeave}
				onDrop={onDrop}
				onClick={openFileDialog}>
				<input
					type="file"
					ref={fileInputRef}
					style={{display:'none'}}
					onChange={onFileAdded}
					accept="video/mp4,video/quicktime,image/*"
				/>
				{statusText}
			</div>
			{alert}
		</>
	)
}
